import React from "react";

/**
 * Formata um valor numérico para o padrão monetário brasileiro (1.234,56).
 * @param {number|string} valor - O valor a ser formatado
 * @returns {string} Valor formatado com 2 casas decimais
 */
export function formatMoney(valor) {
  const numero = Number(valor);
  return new Intl.NumberFormat("pt-BR", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number.isFinite(numero) ? numero : 0);
}

/**
 * Formata um valor monetário com prefixo de moeda (R$ ou USD).
 * @param {number|string} valor - O valor a ser formatado
 * @param {number} moeda - 5 para BRL (Real), 6 para USD (Dólar)
 * @returns {string} Ex: "R$ 1.234,56" ou "USD 1,234.56"
 */
export function formatMoedaSimples(valor, moeda = 5) {
  const prefixo = moeda == 5 ? "R$" : "USD";
  return `${prefixo} ${formatMoney(valor)}`;
}

/**
 * Formata um valor exibindo ambas as moedas (BRL e USD).
 * @param {number|string} valorBrl - Valor em Reais
 * @param {number|string} valorUsd - Valor em Dólares (pode ser nulo)
 * @returns {string} Ex: "R$ 1.234,56 / USD 246,91"
 */
export function formatMoedaAmbas(valorBrl, valorUsd) {
  const brlTexto = formatMoney(valorBrl);
  const usdTexto = Number.isFinite(Number(valorUsd))
    ? formatMoney(valorUsd)
    : "-";
  return (
    <>
      <div style={{ whiteSpace: "nowrap" }}>R$ {brlTexto}</div>
      <div style={{ whiteSpace: "nowrap" }}>USD {usdTexto}</div>
    </>
  );
}